// Stage Crew — Marketplace (compra-venta de material técnico) demo data.

export const MARKET_SECTORS = [
  { id: 'iluminacion', name: 'Iluminación', accent: '#F59E0B', types: ['Consolas', 'Cabezas móviles', 'LED / PAR', 'Convencionales', 'Dimmers / DMX', 'Efectos / humo', 'Cableado', 'Otros'] },
  { id: 'sonido', name: 'Sonido', accent: '#06B6D4', types: ['Consolas', 'PA / altavoces', 'Monitores / IEM', 'Microfonía', 'Inalámbricos', 'Stageboxes / Dante', 'Amplificación', 'Cableado', 'Otros'] },
  { id: 'video', name: 'Vídeo / AV', accent: '#8B5CF6', types: ['Pantallas LED', 'Procesadores', 'Proyectores', 'Media servers', 'Cámaras', 'Cableado SDI/HDMI', 'Otros'] },
  { id: 'rigging', name: 'Rigging', accent: '#E11D48', types: ['Motores', 'Truss', 'Eslingas / grilletes', 'EPI / arneses', 'Bases / torres', 'Otros'] },
  { id: 'maquinaria', name: 'Maquinaria / Escenografía', accent: '#F97316', types: ['Tarimas', 'Telones', 'Practicables', 'Herramienta', 'Otros'] },
  { id: 'electricidad', name: 'Electricidad', accent: '#EAB308', types: ['Cuadros', 'Distribución / Powerlock', 'Cableado', 'Grupos electrógenos', 'Otros'] },
  { id: 'transporte', name: 'Cases / Transporte', accent: '#84CC16', types: ['Flightcases', 'Racks', 'Carros', 'Otros'] },
  { id: 'otros', name: 'Otros', accent: '#94A3B8', types: ['Comunicaciones / walkies', 'Software / licencias', 'Formación', 'Otros'] },
];

export const LISTING_TYPES = [
  { id: 'venta', label: 'Venta' },
  { id: 'alquiler', label: 'Alquiler' },
];

export const RENTAL_PERIODS = [
  { id: 'dia', label: 'día', suffix: '/día' },
  { id: 'semana', label: 'semana', suffix: '/semana' },
  { id: 'mes', label: 'mes', suffix: '/mes' },
  { id: 'evento', label: 'evento', suffix: '/evento' },
];

export const CONDITIONS = [
  { id: 'nuevo', label: 'Nuevo', color: '#10B981' },
  { id: 'como-nuevo', label: 'Como nuevo', color: '#34D399' },
  { id: 'buen-estado', label: 'Buen estado', color: '#F59E0B' },
  { id: 'usado', label: 'Usado', color: '#FB923C' },
  { id: 'para-piezas', label: 'Para piezas', color: '#EF4444' },
];

export const DELIVERY = [
  { id: 'recogida', label: 'Recogida en mano' },
  { id: 'envio', label: 'Envío' },
  { id: 'ambos', label: 'Envío o recogida' },
];

export const MARKET_LISTINGS = [];

export const findSector = (id) => MARKET_SECTORS.find((s) => s.id === id);
export const findCondition = (id) => CONDITIONS.find((c) => c.id === id) || CONDITIONS[2];
export const findPeriod = (id) => RENTAL_PERIODS.find((p) => p.id === id);
export const isRental = (item) => (item?.listing_type || item?.listingType) === 'alquiler';

const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
export const searchListings = (list, { q = '', sector = 'all', type = 'all', condition = 'all', kind = 'all', minPrice = '', maxPrice = '', sort = 'recent' }) => {
  const terms = norm(q).split(/\s+/).filter(Boolean);
  let out = list.filter((l) => {
    if (l.status === 'deleted') return false;
    if (kind !== 'all' && (l.listing_type || 'venta') !== kind) return false;
    if (sector !== 'all' && l.sector !== sector) return false;
    if (type !== 'all' && l.type !== type) return false;
    if (condition !== 'all' && l.condition !== condition) return false;
    if (minPrice !== '' && l.price < Number(minPrice)) return false;
    if (maxPrice !== '' && l.price > Number(maxPrice)) return false;
    if (terms.length) {
      const hay = norm([l.title, l.brand, l.model, l.description, l.location, l.type, findSector(l.sector)?.name].join(' '));
      if (!terms.every((t) => hay.includes(t))) return false;
    }
    return true;
  });
  if (sort === 'price-asc') out = out.sort((a, b) => a.price - b.price);
  else if (sort === 'price-desc') out = out.sort((a, b) => b.price - a.price);
  else out = out.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  return out;
};

export const formatPrice = (n) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);

export const formatListingPrice = (item) => {
  const base = formatPrice(item.price);
  if (isRental(item)) {
    const p = findPeriod(item.rental_period);
    return p ? `${base}${p.suffix}` : base;
  }
  return base;
};
